import React from "react";
import Slider from "react-slick";
import classNames from 'classnames';

import "../../../../css/slick.css";
import "../../../../css/slick-theme.css";


import { RECO_TYPE } from '../../../../constants/common';
import { isInfinite } from '../../../../helpers/recoHelper';

export default function RecommendationsTop5(props) {
    
    const recoTop5Data = props.recommendationsData.recoTop5Data;
    const recoSliderSettings = {	
        className: "center",	
        centerPadding: "0",	
        centerMode: true,	
        infinite: isInfinite(recoTop5Data, 3),
        slidesToShow: 3,	
        slidesToScroll: 1,	
        speed: 500,
        dots: true,
        responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                infinite: isInfinite(recoTop5Data, 2)
              }
            },
            {
              breakpoint: 550,
              settings: {
                slidesToShow: 1,
                infinite: isInfinite(recoTop5Data, 1)
              }
            },
        ],
        afterChange: index => props.onViewRecos(index),
        beforeChange: (oldIndex, newIndex) => props.onChangeSlider(oldIndex, newIndex)
    };
    const recoDetailsEnabled = props.configs['DASHBOARD.RECOMMENDATION_DETAILS_ENABLED'] === "true";
    const recommedationsItemClass = classNames(
        'recommedations-item',
        {'clickable': recoDetailsEnabled}
    );

    return (
        <>
            {recoTop5Data && (recoTop5Data.unviewedRecommendationWrapperList.length > 0 || recoTop5Data.viewedRecommendationWrapperList.length > 0) && (
                <>
                    <p className="recommendations-title">{props.translations["RECOMMENDATIONS.TOP_5.TITLE"]}</p>
                    <div className="recommendations-top-tips">
                        <Slider {...recoSliderSettings} >
        
                            {recoTop5Data.unviewedRecommendationWrapperList.length > 0 && recoTop5Data.unviewedRecommendationWrapperList.map((item, index) => (
                                item && (
                                        <div className={recommedationsItemClass} key={index}
                                            onMouseOver={() => props.onHoverRecos(item.recommendationsMetaData.primaryRecommendationId, RECO_TYPE.CAROUSEL)}
                                            onClick={recoDetailsEnabled ? () => props.handleModal(item.recommendationsMetaData.primaryRecommendationId) : null}
                                        >
                                            <div className="image-details-container">
                                                <div className="recommedations-item-image-container">
                                                    <img src={item.recommendationsMetaData.dashboardIcon} alt={item.recommendationsMetaData.title} />
                                                </div>
                                                <div className="recommedations-item-content">
                                                    <p className="title">{item.recommendationsMetaData.title}</p>
                                                    <p className="description">{item.recommendationsMetaData.description}</p>
                                                </div>
                                            </div>                                            
                                            {
                                                item.recommendationInsight && props.recoInsightsEnabled &&
                                                <div className="reco-insight-container">
                                                    <img src={props.insightBulbImage} alt=""/>
                                                    <div className="insight">
                                                        {item.recommendationInsight}
                                                    </div>
                                                </div>
                                            }
                                        </div>                                   
                                )
                            ))}
        
                            {recoTop5Data.viewedRecommendationWrapperList.length > 0 && recoTop5Data.viewedRecommendationWrapperList.map((item, index) => (
                                item && (
                                        <div className={recommedationsItemClass} key={index}
                                            onMouseEnter={() => props.onHoverRecos(item.recommendationsMetaData.primaryRecommendationId, RECO_TYPE.CAROUSEL)}
                                            onClick={recoDetailsEnabled ? () => props.handleModal(item.recommendationsMetaData.primaryRecommendationId) : null}
                                        >
                                            <div className="image-details-container">
                                                <div className="recommedations-item-image-container">
                                                    <img src={item.recommendationsMetaData.dashboardIcon} alt={item.recommendationsMetaData.title} />
                                                </div>
                                                <div className="recommedations-item-content">
                                                    <p className="title">{item.recommendationsMetaData.title}</p>
                                                    <p className="description">{item.recommendationsMetaData.description}</p>
                                                </div>
                                            </div>
                                            {
                                                item.insight && !!item.insight.insightText && props.recoInsightsEnabled &&
                                                <div className="reco-insight-container">
                                                    <img src={props.insightBulbImage} alt=""/>
                                                    <div className="insight">
                                                        <strong>{props.translations["DASHBOARD.RECOMMENDATIONS.INSIGHT"]}: </strong>{item.insight.insightText}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                )
                            ))}
                        </Slider>
                    </div>
                </>
            )}
        </>
    )
}